<script>
import CapBo from "./capBo.vue";
import CapTruong from "./capTruong.vue";
import CapTinh from "./capTinh.vue";

export default {
  components: {
    CapBo,
    CapTruong,
    CapTinh
  },
  data() {
    return {
      title: "Thông báo",
      dofficeTitle: " | DOffice - Đại học Đồng Tháp"
    };
  },
  validations: {},
  created() {
    document.title = "Thông báo cấp trường" + this.dofficeTitle;
  },
  watch: {
    currentPage: {},
    computed: {},
    methods: {}
  },
  methods: {
    changeTitleInHeader(title) {
      document.title = title + this.dofficeTitle;
    }
  }
}
</script>

<template>
  <div>
    <div class="row p-2">
      <div class="col-12">
        <b-tabs content-class="" nav-class="cs-tabs">
          <b-tab active class="border-0" @click="changeTitleInHeader('Thông báo cấp trường')">
            <template v-slot:title>
              <div>
                                        <span class="d-inline-block d-sm-none">
                                            <i class="fas fa-home"></i>
                                        </span>
                <span class="d-none d-sm-inline-block"> Cấp trường</span>
              </div>
            </template>
            <p>
              <CapTruong/>
            </p>
          </b-tab>
          <b-tab @click="changeTitleInHeader('Thông báo cấp tỉnh')">
            <template v-slot:title>
              <div>
                                        <span class="d-inline-block d-sm-none">
                                            <i class="far fa-user"></i>
                                        </span>
                <span class="d-none d-sm-inline-block"> Cấp tỉnh</span>
              </div>

            </template>
            <p>
              <CapTinh/>
            </p>

          </b-tab>
          <b-tab @click="changeTitleInHeader('Thông báo cấp bộ')">
            <template v-slot:title>
              <div>
                                        <span class="d-inline-block d-sm-none">
                                            <i class="far fa-envelope"></i>
                                        </span>
                <span class="d-none d-sm-inline-block"> Cấp bộ</span>
              </div>

            </template>
            <p>
              <CapBo/>
            </p>

          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>
